import styled from 'styled-components';

import Box from '../components/layout/Box';
import FullScreenLoader from '../components/FullScreenLoader';
import FullScreenError from '../components/FullScreenError';

const StyledBox = styled(Box)`
  flex-grow: 1;

  @media (max-width: 1200px) {
    padding: 15px;
  }
  @media (min-width: 1200px) {
    padding: 20px;
  }
  @media (min-width: 1600px) {
    padding: 24px;
  }
`;

const ContentHandler = ({ loading, error, onRetry, children, ...other }) => {
  if (loading) {
    return (
      <StyledBox>
        <FullScreenLoader />
      </StyledBox>
    );
  }

  if (error) {
    return (
      <StyledBox>
        <FullScreenError onRetry={onRetry} />
      </StyledBox>
    );
  }

  return <StyledBox {...other}>{children}</StyledBox>;
};

export default ContentHandler;
